import { memo } from "react";

import type { InputMaybe, LangCode } from "@/lib/gql/__generated__/graphql";

import { UpdateAndResendGuestEmailOfReservationDetailDialog } from "../../components";
import { BasicInfoLabelWithTextLayout } from "../../layout";

type Props = {
	guestEmail: string;
	onUpdate: (guestEmail: InputMaybe<string> | undefined, langCode: InputMaybe<LangCode> | undefined) => Promise<void>;
};

export const GuestEmailOfBasicInfoCompositions = memo(({ guestEmail, onUpdate }: Props) => {
	return (
		<div className="flex flex-wrap gap-x-5 sm:gap-x-10">
			<BasicInfoLabelWithTextLayout
				label="Email"
				textChildren={
					<div className="flex flex-wrap items-center gap-x-4 gap-y-2">
						<p>{guestEmail}</p>
						<UpdateAndResendGuestEmailOfReservationDetailDialog
							email={guestEmail}
							onUpdateAndResendGuestEmail={onUpdate}
						/>
					</div>
				}
			/>
		</div>
	);
});
